import { useEffect, useState } from 'react';
import FontFaceObserver from 'fontfaceobserver';
export var useFontLoader = function (isPartnerConfigLoaded, fonts) {
    var _a = useState(false), fontLoaded = _a[0], setFontLoaded = _a[1];
    var _b = useState(), fontName = _b[0], setFontName = _b[1];
    var previewUrl = fonts === null || fonts === void 0 ? void 0 : fonts.previewUrl;
    var previewName = fonts === null || fonts === void 0 ? void 0 : fonts.preview;
    var defaultUrl = fonts === null || fonts === void 0 ? void 0 : fonts.defaultUrl;
    var defaultName = fonts === null || fonts === void 0 ? void 0 : fonts.default;
    useEffect(function () {
        if (!isPartnerConfigLoaded || fontLoaded) {
            return;
        }
        if (previewName && previewUrl) {
            loadFont(previewName, previewUrl)
                .then(function () {
                setFontName(previewName);
                setFontLoaded(true);
            })
                .catch(function () {
                if (defaultName && defaultUrl) {
                    loadDefaultFont(defaultName, defaultUrl, setFontName, setFontLoaded);
                }
                else {
                    loadGoogleFont(setFontName, setFontLoaded);
                }
            });
        }
        else if (defaultName && defaultUrl) {
            loadDefaultFont(defaultName, defaultUrl, setFontName, setFontLoaded);
        }
        else {
            loadGoogleFont(setFontName, setFontLoaded);
        }
    }, [isPartnerConfigLoaded, previewUrl, previewName, defaultUrl, defaultName, fontLoaded]);
    return { fontLoaded: fontLoaded, fontName: fontName };
};
var loadFont = function (fontName, fontUrl) {
    var head = document.getElementsByTagName('head')[0];
    var partnerFont = document.createElement('style');
    partnerFont.appendChild(document.createTextNode('@font-face{font-family: ' + fontName + '; src: url(' + fontUrl + ');}'));
    head.appendChild(partnerFont);
    return new FontFaceObserver(fontName).load();
};
var loadDefaultFont = function (defaultName, defaultUrl, setFontName, setFontLoaded
// eslint-disable-next-line max-params
) {
    loadFont(defaultName, defaultUrl)
        .then(function () {
        setFontName(defaultName);
        setFontLoaded(true);
    })
        .catch(function () {
        loadGoogleFont(setFontName, setFontLoaded);
    });
};
var loadGoogleFont = function (setFontName, setFontLoaded) {
    var head = document.getElementsByTagName('head')[0];
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=Rubik:wght@400;500&display=swap';
    head.appendChild(link);
    new FontFaceObserver('Rubik')
        .load()
        .then(function () {
        setFontName('Rubik');
        setFontLoaded(true);
    })
        .catch(function () {
        setFontName(undefined);
        setFontLoaded(true);
    });
};
